import React from 'react';
import ProductsForm from './ProductsForm'; // Adjust path

const NewProductPage = () => {
  return (
    <>
     <ProductsForm formType='create' currentProductId={null} />
    </>
  );
};

export default NewProductPage;